import Avatar from "../../../antd/Avatar";
import { UserOutlined } from "@ant-design/icons";

export default function PopupTitle({
  vehicleimg,
  driverimg,
  headtitle,
  subtitle,
  nospace,
  avatar,
  avatarSrc,
}) {
  return (
    <>
      <div
        className="d-flex align-items-center"
        style={{ justifyContent: "flex-start" }}
      >
        {avatar && (
          <div className={`me-3`}>
            <Avatar
              size={64}
              src={avatarSrc ? avatarSrc : ""}
              fallback={<UserOutlined />}
            />
          </div>
        )}
        <div className={`${driverimg ? "me-3" : "me-1"}`}>
          {driverimg ? (
            <img src={`${driverimg}`} alt="" className="driver-img" />
          ) : (
            <img
              src={`${process.env.PUBLIC_URL}/assets/${vehicleimg}`}
              alt=""
            />
          )}
        </div>
        <div>
          <div className="fs-16 fw-600 neutral-700 text-capitalize">
            {headtitle}
          </div>
          <div className="fs-14 fw-400 neutral-500 text-capitalize mt-2">
            {subtitle}
          </div>
        </div>
      </div>
    </>
  );
}
